import React from 'react';
import { Typography, Grid } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import { InspectionsLink } from 'utils/link';
import { IndexListItemButton } from 'components/styles_components/list';
const InspectionsCard = ({ label, total, setInspectionsFilter, className = '', icon = '' }) => {
  const navigate = useNavigate();

  return (

    <Grid size={{ xs: 12, md: 4 }}>
      <IndexListItemButton
        onClick={() => {
          setInspectionsFilter();
          navigate(InspectionsLink());
        }}
        className={className}>
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          {label}
          {icon}
        </Grid>
        <Typography variant="button">
          {total}
        </Typography>
      </IndexListItemButton>
    </Grid>
  );
};

export default InspectionsCard;
